<div class="progress-input">
  <div class="input-container">
    <app-mic-vad
      (audioRecorded)="handleAudioRecorded($event)"
      (statusChanged)="handleMicStatusChanged($event)"
      [continueListening]="shouldContinueListening()" />

    <textarea pTextarea [formControl]="chatInputControl" (keyup.enter)="sendUserMessage()" rows="1"></textarea>

    <p-button (click)="sendUserMessage()" [disabled]="isAIThinking() || !chatInputControl.value" label="Enviar" [rounded]="true" />
  </div>

  @if(taskOnUserMessage()) {
  <div (click)="setScore(100)">
    <p-progressbar showValue="false" [value]="score()" [style]="{ height: '6px' }" />
  </div>
  }
</div>
